import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLive$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLive extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'eb7e2a944c8b3cc48ed30de7affbc3c2bdfd23f8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'efc23f30311052e769b0ef3d175f528eadcc317c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7cb9e3d739206b596e382e678ebc766aa6296fde', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M7.5 11a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-live", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-live"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-live":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLive$1);
            }
            break;
    } });
}

const CosmosIconLive = CosmosIconLive$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLive, defineCustomElement };
